import { useSelector } from 'react-redux';
import { RootState } from 'src/store/store';
import { getLabelFallback } from '@utils/utils';

interface Props {
    setQuantity: (boxes: number) => void;
}

const noDiscount = {
    annualSupplyBoxes: 0,
    sixMonthsSupplyBoxes: 0,
    annualSupplySavings: 0,
    sixMonthsSupplySavings: 0,
};

const CLDiscounts = ({ setQuantity }: Props) => {
    const config = useSelector((state: RootState) => state.common.config);

    const discountData = config?.discountData || noDiscount;

    const { annualSupplyBoxes, sixMonthsSupplyBoxes, annualSupplySavings, sixMonthsSupplySavings } =
        discountData;

    const showAnnualSupply = annualSupplyBoxes > 0;
    const showSixMonthsSupply = sixMonthsSupplyBoxes > 0;

    // only show this section if there are discounts available
    const showDiscountSection = showAnnualSupply || showSixMonthsSupply;

    const annualBoxesPerEye = annualSupplyBoxes / 2;
    const sixMonthsBoxesPerEye = sixMonthsSupplyBoxes / 2;

    return (
        <>
            {showDiscountSection && (
                <div className="contact-lens-discount-container">
                    {showAnnualSupply && (
                        <button
                            className="contact-lens-discount"
                            onClick={() => setQuantity(annualBoxesPerEye)}
                        >
                            <b>
                                {getLabelFallback('ADD_NEW_PRESCRIPTION_DISCOUNT_LABEL_1')}
                                <span className="discount-price">${annualSupplySavings}</span>
                            </b>
                            {getLabelFallback('ADD_NEW_PRESCRIPTION_DISCOUNT_LABEL_2')}
                            {annualSupplyBoxes}
                            {getLabelFallback('ADD_NEW_PRESCRIPTION_DISCOUNT_LABEL_3')}
                        </button>
                    )}

                    {showSixMonthsSupply && (
                        <button
                            className="contact-lens-discount"
                            onClick={() => setQuantity(sixMonthsBoxesPerEye)}
                        >
                            <b>
                                {getLabelFallback('ADD_NEW_PRESCRIPTION_DISCOUNT_LABEL_1')}
                                <span className="discount-price">${sixMonthsSupplySavings}</span>
                            </b>
                            {getLabelFallback('ADD_NEW_PRESCRIPTION_DISCOUNT_6_MONTHS_LABEL_2')}
                            {sixMonthsSupplyBoxes}
                            {getLabelFallback('ADD_NEW_PRESCRIPTION_DISCOUNT_LABEL_3')}
                        </button>
                    )}
                </div>
            )}
        </>
    );
};

export default CLDiscounts;
